module.exports = __webpack_public_path__ + "img/menu (1).b5378ad4.jpg";